/* eslint-disable no-console */
/* eslint-disable react/no-danger */
/* eslint-disable no-cond-assign */
import './uigrid.css';
import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import exportFromJSON from 'export-from-json';
import { Menu, MenuItem, Typography } from '@mui/material';
import { copyCell, copyCellHead, copyColHead, copyRowHead, copyTable, handler } from './helper';
import SelectInput from './select-input';
import BasicInput from './basic-input';

function UIGrid(props) {
  const { t } = useTranslation();
  const { properties, options, data, filename, headerData, checkCustomHeader, tableClassName } = props;
  const [fileName] = useState(filename || 'export');
  const [griddata, setGridData] = useState(data || []);
  const [selectOptions] = useState(options || []);
  const [targetValue, setTargetValue] = useState('');
  const [targetElement, setTargetElement] = useState('');

  function updateInput(e) {
    const { value, id } = e.target;
    const flag = id.indexOf('_', 9);
    const row = Number(id.substring(9, flag)) - 1;
    const col = Number(id.substring(flag + 1)) - 1;
    const field = properties[col].tag;
    const updatedGrid = griddata;
    updatedGrid[row][field] = value;
    setGridData([...updatedGrid]);
    if (props.onchange)
      props.onchange(e);
  }

  function changeFocus(e) {
    if (e.target && typeof e.target.select === 'function')
      e.target.select();
    if (props.onfocus)
      props.onfocus(e);
  }

  const handleRightClick = (e) => {
    setTargetElement(e.target.id);
    setTargetValue(e.target.value);
    $('.react-contextmenu').css({ display: 'block' });
  };

  function setData(formdata) {
    setGridData(formdata);
  }

  useEffect(() => {
    setData(data);
  }, [data]);

  useEffect(() => {
    document.addEventListener('click', () => {
      $('.react-contextmenu').css({ display: 'none' });
    });
  }, []);

  const isHTML = (str) => {
    const a = document.createElement('div');
    a.innerHTML = str;
    for (let c = a.childNodes, i = c.length; i -= 1;) {
      if (c[i].nodeType === 1) return true;
    }
    return false;
  };
  const getInputValue = (data, properties) => {
    let finalVal = '';
    if (data[properties.tag] !== null) {
      finalVal = (data[properties.tag] === 'B-') ? 'B' : data[properties.tag];
    }
    if (t(finalVal)) {
      const flagHtml = isHTML(t(finalVal));
      if (flagHtml) {
        return { flag: flagHtml, data: t(finalVal) };
      }
      return t(finalVal);
    };
  };
  // Added by Abhishek on 5-feb-24 : for csv/excel export issue
  const [contextMenu, setContextMenu] = React.useState(null);
  const handleContextMenu = (event) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
          mouseX: event.clientX + 2,
          mouseY: event.clientY - 6,
        }
        : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
        // Other native context menus might behave different.
        // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
        null,
    );
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  return (
    (griddata !== [] && properties !== [] && griddata !== null && properties !== null) ?
      <div className='UIGrid' onContextMenu={handleContextMenu} style={{ cursor: 'context-menu' }}>
        <table id='grid' className={tableClassName}>
          <thead>{
            !checkCustomHeader &&
            <tr className='header_row'>
              {properties.map((properties, key) => {
                const className = properties.st || 0;
                if (className) {
                  return (
                    <th
                      style={{ minWidth: `${className}px` }}
                      key={key}
                      className='hcell'
                      id={`hcell_${key}`}
                      aria-label="hdata"
                      dangerouslySetInnerHTML={{ __html: properties.hdata }}
                    />
                  );
                }
                return (
                  <th
                    key={key}
                    className='hcell'
                    id={`hcell_${key}`}
                    aria-label="hdata"
                    dangerouslySetInnerHTML={{ __html: properties.hdata }}
                  />
                );
              })}
            </tr>
          }{checkCustomHeader && <>
            {
              headerData.map((headProps, key) => {
                return (<tr key={key} className='header_row'>
                  {headProps.map((properties, key) => {
                    return (<th key={key} className='hcell' colSpan={properties.colspan} >{properties.hdata}</th>);
                  })}
                </tr>
                );
              })
            }
          </>}
          </thead>
          <tbody>
            {griddata.map((data, row) => {
              return (<tr key={row} className={((row + 1) % 2 === 0) ? `row_${row + 1} row-even` : `row_${row + 1} row-odd`}>
                {properties.map((properties, col) => {
                  return (
                    <td id={`cell${col + 1}`} key={col} className={`cell cell_${row + 1}_${col + 1}`}>
                      {(properties.datatype === 'select' && selectOptions !== []) &&
                        <Typography>
                          <SelectInput
                            id={(properties.id) ? `input_num${row + 1}_${col + 1} ${properties.id}` : `input_num${row + 1}_${col + 1}`}
                            className={properties.className || ''}
                            value={(data[properties.tag] !== null) ? data[properties.tag] : ''}
                            disabled={properties.disabled || null}
                            onBlur={props.onblur || null}
                            onClick={props.onclick || null}
                            onChange={(e) => { updateInput(e); }}
                            onFocus={(e) => { changeFocus(e); }}
                            onContextMenu={handleRightClick}
                            onKeyDown={(e) => handler(e)}
                            SelOption={selectOptions[row][properties.tag]}
                          />
                        </Typography>

                      }{(properties.datatype !== 'select') &&
                        <Typography id='custom_menu'>
                          {(() => {
                            if (properties.datatype !== 'button') {
                              const flagObject = getInputValue(data, properties);
                              if (Object.prototype.toString.call(flagObject) === '[object Object]') {
                                return (
                                  <span
                                    id={(properties.id) ? `input_num${row + 1}_${col + 1} ${properties.id}` : `input_num${row + 1}_${col + 1}`}
                                    className={properties.className || ''}
                                    dangerouslySetInnerHTML={{ __html: flagObject.data }}
                                  />
                                );
                              }
                            }
                            return (
                              <BasicInput
                                id={(properties.id) ? `input_num${row + 1}_${col + 1} ${properties.id}` : `input_num${row + 1}_${col + 1}`}
                                className={properties.className || ''}
                                type={properties.datatype || ''}
                                value={properties.datatype === 'button' ? '' : getInputValue(data, properties)}
                                disabled={properties.disabled || null}
                                onBlur={props.onblur || null}
                                onClick={props.onclick || null}
                                onChange={(e) => { updateInput(e); }}
                                onFocus={(e) => { changeFocus(e); }}
                                onContextMenu={handleRightClick}
                                onKeyDown={(e) => handler(e)}
                                src={properties.src || null}
                                alt={properties.alt || null}
                                autoComplete={properties.autoComplete || null}
                                max={properties.max || null}
                                min={properties.min || null}
                                minLength={properties.minLength || null}
                                maxLength={properties.maxLength || null}
                                multiple={properties.multiple || null}
                                placeholder={properties.placeholder || null}
                                checked={properties.checked || null}
                              />
                            );
                          })()}
                        </Typography>
                      }
                    </td>
                  );
                })}
              </tr>);
            })}
          </tbody>
        </table>
        <Menu id='custom_menu'
          open={contextMenu !== null}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={
            contextMenu !== null
              ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
              : undefined
          }
        >
          <MenuItem onClick={() => { copyCell(targetValue); handleClose(); }}>
            <span>Copy</span>
          </MenuItem>
          <MenuItem onClick={() => { copyCellHead(targetElement, properties, targetValue); handleClose(); }}>
            <span>Copy Cell with Headers</span>
          </MenuItem>
          <MenuItem onClick={() => { copyRowHead(targetElement, properties, griddata); handleClose(); }}>
            <span>Copy Row with Headers</span>
          </MenuItem>
          <MenuItem onClick={() => { copyColHead(targetElement, properties, griddata); handleClose(); }}>
            <span>Copy Column with Headers</span>
          </MenuItem>
          <MenuItem onClick={() => { copyTable(properties, griddata); handleClose(); }}>
            <span>Copy Table </span>
          </MenuItem>
          <MenuItem onClick={() => { exportFromJSON({ data: griddata, fileName, exportType: 'csv' }); handleClose(); }}>
            <span>Export as CSV</span>
          </MenuItem>
          <MenuItem onClick={() => {
            const worksheet = XLSX.utils.json_to_sheet(griddata);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            XLSX.writeFile(workbook, `${fileName}.xlsx`);
            handleClose();
          }}>
            <span>Export as Excel</span>
          </MenuItem>
        </Menu>
      </div> : (<>Please Enter the Data in Format</>)
  );
}
export default UIGrid;